var a = Object.defineProperty;
var o = (n, e, t) => e in n ? a(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var s = (n, e, t) => o(n, typeof e != "symbol" ? e + "" : e, t);
import { HttpClient as p, httpClient as i } from "../../httpClient.js";
class l extends p {
  constructor() {
    super(...arguments);
    s(this, "endpoint", "/newlane-tutorials");
  }
  async getAll() {
    return i.get(this.endpoint);
  }
  async getOne(t) {
    return i.get(`${this.endpoint}/${t}`);
  }
  async create(t) {
    return i.post(this.endpoint, t);
  }
  async update(t, r) {
    return i.put(`${this.endpoint}/${t}`, r);
  }
  async remove(t) {
    return i.delete(`${this.endpoint}/${t}`);
  }
}
const c = new l();
export {
  c as default
};
